module.exports = __webpack_public_path__ + "mainassets/img/graf5.7c0d8de9.svg";